"use client";
import { ProductJsonLd } from "next-seo";
import { useSearchParams } from "next/navigation";
import { buildProductJsonLd } from "./product";
const ProductMeta = ({ productData }: { productData: any }) => {
  const searchParams = useSearchParams();
  const currency = searchParams.get("currency");
  return (
    <ProductJsonLd
      {...buildProductJsonLd(productData, currency as string)}
      useAppDir={true}
    />
  );
};
export default ProductMeta;
